import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { roleRoutes } from "../config/roles";

export default function ProtectedRedirect() {
  const { currentUser } = useSelector((state) => state.user);
  if (!currentUser) return <Navigate to="/login" replace />;

  const path = roleRoutes[currentUser.role] || "/";
  return <Navigate to={path} replace />;
}
